import * as React from "react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { usePermissions } from "@/hooks/usePermission";

type ButtonProps = React.ComponentProps<typeof Button>;

type PermissionIconButtonProps = Omit<ButtonProps, "size"> & {
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
  label: string;
  noPermissionLabel?: string;
  size?: "icon" | "sm" | "default" | "lg";
  destructive?: boolean;
};

export function PermissionIconButton({
  permission,
  permissions,
  requireAll = false,
  label,
  noPermissionLabel = "Você não possui permissão para esta ação",
  disabled,
  destructive = false,
  className = "",
  children,
  ...props
}: PermissionIconButtonProps) {
  const allowed = usePermissions(
    permission ? [permission, ...(permissions ?? [])] : permissions,
    { requireAll },
  );

  const finalDisabled = disabled || !allowed;
  const tooltipLabel = !allowed ? noPermissionLabel : label;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            disabled={finalDisabled}
            className={`${destructive ? "text-destructive hover:text-destructive" : ""} ${className}`}
            {...props}
          >
            {children}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tooltipLabel}</p>
      </TooltipContent>
    </Tooltip>
  );
}
